<template>
  <div>
    <sweet-modal ref="modal" :title="title" width="35%" hide-close-button blocking>
      <div class="mt-1 mx-1 mb-5" v-if="type === 'connect' || type === 'change'">

        <div class="form-group" v-if="type === 'connect'">
          <label for="name" class="text-wrap">{{ $t('ct-domain')}}</label>
          <input
            type="text"
            name="name"
            id="name"
            autocomplete="off"
            required="required"
            v-model="domain.name"
            class="form-control mb-1"
            :class="{'is-invalid': errors && errors.has('domain.name')  }"
            @keydown="errors.clear('domain.name')"
          />
          <span class="helper" v-html="$t('ct-connect-domain-helper')"></span>
          <span
            v-if="errors.has('domain.name')"
            class="invalid-feedback"
            v-text="errors.get('domain.name')"
          ></span>
        </div>

      </div>

      <div v-else-if="type === 'disconnect'">

        <h5>{{ $t('ct-domain') }} : <strong>  {{ (site && site.dominio ? (site.domain_unicode || site.dominio) : '') }}</strong></h5>
        <br>
        <p>{{ $t('ct-domain-message-steps') }}</p>
        <br>
        <ul>
          <li>{{ $t('ct-domain-step-1') }}</li>
          <li>{{ $t('ct-domain-step-2') }}</li>
          <li>{{ $t('ct-domain-step-3') }}</li>
        </ul>

        <br>
        <p>   IP 1: <strong>  {{ info.ip1 }}</strong></p>
        <p>   IP 2: <strong>  {{ info.ip2 }}</strong></p>
        <p>  Name Server 1: <strong>  {{ info.ns_1 }}</strong></p>
        <p>  Name Server 2: <strong> {{ info.ns_2 }}</strong></p>



        </div>

      <div v-if="type === 'connect'" class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row justify-content-end">
        <button slot="button" class="btn btn-outline-light" v-on:click="cancel()">{{ $t('ct-cancel') }}</button>
        <button slot="button" class="btn btn-success" v-on:click="save(type)">{{ $t('ct-next')}}</button>
      </div>
      <div v-else>
        <div class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row" style="justify-content: space-between; margin-top: 5px">
          <button slot="button" class="btn btn-danger" style="margin-left: 0px" v-on:click="save(type)">{{ $t('ct-domain-disconnect')}}</button>
          <button slot="button" class="btn btn-outline-light" v-on:click="cancel()">{{ $t('ct-close') }}</button>

        </div>
      </div>
    </sweet-modal>

    <sweet-modal
      ref="confirmConnect"
      :title="this.$t('ct-connect-domain-confirm')"
      width="30%"
      hide-close-button
      blocking
    >
      <div>
        <p>{{$t('want-connect-domain')}}:  <strong>{{ this.domain.name }}</strong> </p>
      </div>
      <button slot="button" class="btn btn-outline-light" v-on:click="cancelConfirmConnect()">{{ $t('ct-cancel')}}
      </button>
      <button slot="button" class="btn btn-success" v-on:click="saveDomain()"><i class="svg-icon svgi-save"></i>{{ $t('ct-confirm-template-save')}}</button>
    </sweet-modal>


    <sweet-modal ref="confirmDisconnect"   icon="warning" width="30%"
                 hide-close-button blocking>
      <div style="text-align: center;">
        <h4> {{ $t('title-disconnect-domain-confirm') }} </h4> <br />
        <p v-if="site && site.dominio">{{$t('ct-domain')}}: {{ site.domain_unicode || site.dominio }}</p>
      </div>
      <div style="margin-top: 35px" class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row justify-content-end">
        <button slot="button" class="btn btn-outline-light" v-on:click="cancelConfirm()">{{ $t('ct-cancel')}}</button>
        <button slot="button" class="btn btn-danger" v-on:click="disconnectDomain()">{{ $t('ct-domain-disconnect-action') }}</button>
      </div>
    </sweet-modal>

  </div>
</template>

<script>
import {SweetModal, SweetModalTab} from 'sweet-modal-vue';
import Errors from '../../../../js/base/Errors';
import {get as getServers} from '../../../../js/services/editor/globalservers';
import {connect, disconnect } from '../../../../js/services/editor/domain';
import axios from 'axios'

export default {
  props: ['site', 'show', 'title', 'type'],
  components: {SweetModal},

  data() {
    return {
      errors: new Errors(),
      info: {
        ip1: '',
        ip2: '',
        ns_1: '',
        ns_2: ''
      },
      domainConnected: '',
      domain: {
        name: '',
        region: 101
      },
      regions: []
    };
  },

  watch: {
    show: function(value) {
      if(this.type === 'disconnect') { this.getInfo() }
      if (value) this.$refs.modal.open();
      else this.$refs.modal.close();
    }
  },

  methods: {
    getInfo() {
      let vm = this;
        axios.get(`https://dns.builderall.com/api/domain/get-ns?domain=${vm.site.dominio}`)
        .then( res => {
          if (res.data.success) {
            vm.info.ip1 = res.data.ip_addresses.ip_1;
            vm.info.ip2 = res.data.ip_addresses.ip_2;
            vm.info.ns_1 = res.data.ns_servers.server_1;
            vm.info.ns_2 = res.data.ns_servers.server_2;
          }
        } )
    },
    getInfo2() {
      let vm = this;
        axios.get(`https://dns.builderall.com/api/domain/get-ns?domain=${vm.domainConnected}`)
        .then( res => {
          if (res.data.success) {
            vm.info.ip1 = res.data.ip_addresses.ip_1;
            vm.info.ip2 = res.data.ip_addresses.ip_2;
            vm.info.ns_1 = res.data.ns_servers.server_1;
            vm.info.ns_2 = res.data.ns_servers.server_2;
          }
        } )
    },
    cancel() {
      this.$emit('cancel', 'domain');
    },
    save(type) {
      switch (type) {
        case 'connect':
          this.connectDomain();
          break;
        case 'change':
          this.connectDomain();
          break;
        case 'disconnect':
          this.getInfo();
          this.confirmDesconnect();
          break;
      }
    },

    validate() {
      if (!this.domain.name || this.domain.name.trim().length === 0 || this.domain.name.trim().length <= 3) { this.errors.add('name', 'validation-required', 'domain') }

      if (!this.domain.region) { this.errors.add('region', 'validation-required', 'domain') }

      return this.errors.any();
    },

    connectDomain() {
      if (!this.validate()) {
        this.confirmConnect();
      }
    },

    saveDomain() {
      this.$loading.show();
      let obj = this.domain;
      obj.encrypted_id = this.site.encrypted_id;
      let vm = this;

      connect(this.domain)
        .then(res => {
          this.cancelConfirmConnect();

          let data = res.data.data;

          if (!res.data.success) {
            this.$snotify.error(res.data.error, {timeout: 7000});

            return;
          }

          let dns = data.dns;
          vm.domainConnected = dns.domain;
          vm.getInfo2();
          this.$emit('setDomain', {domain: dns.domain});
          this.$snotify.success(this.$t('ct-success-connect'));


          this.configDomain(dns.domain);

          // this.cancel();
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => this.$loading.hide());
    },

    confirmConnect() {
      this.$refs.confirmConnect.open();
    },

    cancelConfirmConnect() {
      this.$refs.confirmConnect.close();
    },

    confirmDesconnect() {
      this.$refs.confirmDisconnect.open();
    },

    cancelConfirm() {
      this.$refs.confirmDisconnect.close();
      this.cancel();
    },

    clearObj() {
    },

    configDomain() {

    let obj = this.domain;
      obj.encrypted_id = this.site.encrypted_id;
      config(obj)
      .then( res => {
        console.log(res)
      } )

    },

    disconnectDomain() {
      this.$loading.show();

      let obj = this.domain;
      obj.encrypted_id = this.site.encrypted_id;
      disconnect(this.domain)
        .then(res => {

          if (!res.data.success) {
            this.$snotify.error(res.data.error, {timeout: 7000});

            return;
          }

          this.$emit('setDomain', {domain: null});
          this.$loading.hide();
          this.$emit('cancel');

          this.$snotify.success(this.$t('ct-success-disconnect'));
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => this.$loading.hide());

      this.$refs.confirmDisconnect.close();
      this.cancel();
    },

    changeRegion() {
      console.log('changeRegion');
    },

    getTitle() {
    }
  }
};
</script>

<style lang="scss" scoped>

.sweet-modal {
  background: red;;
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SiteDomain.vue